import { IDonorRegistration } from '@nkr/models/index';
import { Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    donor: IDonorRegistration,
    onReverseRuleOut: () => void,
    onCancel: () => void
}

const ReverseRuleOut = (props: IProps) => {
    let firstName = props.donor != null ? props.donor.firstName : '';
    let lastName = props.donor != null ? props.donor.lastName : '';

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>Reverse Rule Out</Modal.Header>
            <Modal.Body>
                <div style={{ marginBottom: 5 }}>Reverse the rule-out of this donor?</div>
                <blockquote style={{ paddingLeft: 10 }}>{firstName} {lastName}</blockquote>
            </Modal.Body>
            <Modal.Footer style={{ borderTop: '0 none' }}>
                <Button bsStyle='primary' onClick={props.onReverseRuleOut}>Confirm</Button>
                <Button onClick={props.onCancel}>No, Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ReverseRuleOut;